var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperlessV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2706",
    "data-name": "Rectangle 2706",
    width: 84,
    height: 83,
    transform: "translate(0.347 0.5)",
    fill: "#1b7934"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850",
    transform: "translate(0.101 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 84,
    height: 4,
    transform: "translate(-0.101 79.5)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    "data-name": "Group 1849",
    transform: "translate(-0.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1848",
    "data-name": "Group 1848",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14688",
    "data-name": "Path 14688",
    d: "M73.922,153.515v-5.1a10.134,10.134,0,0,0,8.906-10.045V123.8a10.091,10.091,0,0,0-3.162-7.338,13.239,13.239,0,0,0,.895-4.807,13.354,13.354,0,0,0-20.947-10.99,8.5,8.5,0,0,0-15,5.485v17.813a8.459,8.459,0,0,0,1.043,4.066q-3.5-.924-7.683-1.657v-13.1a10.117,10.117,0,0,0-13.961-9.362,10.122,10.122,0,0,0-19.721,3.208v11.3a14.97,14.97,0,0,0,9.554,25.33v9.765H0v2.429H28.158l.171-.052a53.258,53.258,0,0,0,8.174-3.36c5.735-2.972,8.831-6.215,9.2-9.64.388-3.568-2.215-7.026-7.735-10.288v-3.765a71.838,71.838,0,0,1,12.469,3.237v1.44a11.758,11.758,0,0,0,10.01,11.612c-1.7,4.714-6.724,8.593-6.778,8.635l-2.867,2.181h32.1v-2.429ZM6.72,107.121a7.692,7.692,0,0,1,15.124-1.985,10.112,10.112,0,0,0-4.112,8.138v.806a14.974,14.974,0,0,0-11.011,2.3Zm7.125,27.188-4.08-4.08-1.717,1.717,5.8,5.8v3.566a12.55,12.55,0,1,1,2.429,0v-8.424l5.8-5.8-1.717-1.717-4.08,4.08v-5.489H13.845Zm12.793,19.206H16.274v-9.765a14.868,14.868,0,0,0,4.145-.943,10.015,10.015,0,0,0,6.219,3.187Zm1.214-9.878a7.625,7.625,0,0,1-5.122-1.956,14.975,14.975,0,0,0-2.569-26.945v-1.462a7.692,7.692,0,0,1,15.384,0v22.671a7.7,7.7,0,0,1-7.692,7.692m15.441-1.009c-.514,4.736-9.415,8.786-14.227,10.467v-7.1a10.134,10.134,0,0,0,8.906-10.045v-.487c3.781,2.459,5.57,4.866,5.32,7.17m23.908-41.9a10.926,10.926,0,0,1,10.418,14.231,10.044,10.044,0,0,0-3.867-1.223,11.757,11.757,0,0,0-11.572-9.77c-.284,0-.564.014-.843.034a8.459,8.459,0,0,0-.441-1.269A10.935,10.935,0,0,1,67.2,100.724Zm-16.76,28.691a6.1,6.1,0,0,1-3.4-5.453V106.149a6.073,6.073,0,0,1,11.895-1.726,11.759,11.759,0,0,0-8.494,11.28Zm10.526,24.1H57.591a26.269,26.269,0,0,0,3.376-4.094Zm0-19.206-2.137-2.137-1.717,1.717,3.854,3.854v5a9.323,9.323,0,0,1-8.1-9.229V115.7a9.311,9.311,0,0,1,18.622,0v17.813a9.323,9.323,0,0,1-8.1,9.229v-9.86l3.854-3.854-1.717-1.717L63.4,129.45v-6.3H60.968Zm10.526,19.206H63.4v-8.321a11.663,11.663,0,0,0,1.592-.279,10.153,10.153,0,0,0,6.5,3.507Zm-4.027-9.52a11.751,11.751,0,0,0,6.456-10.479V116.2a7.7,7.7,0,0,1,6.477,7.6v14.574a7.685,7.685,0,0,1-12.933,5.621",
    transform: "translate(0.698 -81.293)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14689",
    "data-name": "Path 14689",
    d: "M199.763,40.526a5.263,5.263,0,1,0-5.263-5.263,5.269,5.269,0,0,0,5.263,5.263m0-8.1a2.834,2.834,0,1,1-2.834,2.834,2.837,2.837,0,0,1,2.834-2.834",
    transform: "translate(-162.306 -25.142)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2698",
    "data-name": "Rectangle 2698",
    width: 2.429,
    height: 2.429,
    transform: "translate(36.243)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2699",
    "data-name": "Rectangle 2699",
    width: 2.429,
    height: 2.429,
    transform: "translate(36.243 17.813)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2700",
    "data-name": "Rectangle 2700",
    width: 2.429,
    height: 2.429,
    transform: "translate(27.336 8.906)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    width: 2.429,
    height: 2.429,
    transform: "translate(45.149 8.906)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2702",
    "data-name": "Rectangle 2702",
    width: 2.429,
    height: 2.429,
    transform: "translate(29.438 3.826) rotate(-45)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2703",
    "data-name": "Rectangle 2703",
    width: 2.429,
    height: 2.429,
    transform: "translate(42.031 16.421) rotate(-45)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2704",
    "data-name": "Rectangle 2704",
    width: 2.429,
    height: 2.429,
    transform: "translate(29.437 16.42) rotate(-45)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2705",
    "data-name": "Rectangle 2705",
    width: 2.429,
    height: 2.429,
    transform: "translate(42.033 3.827) rotate(-45)",
    fill: "#1b7934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14690",
    "data-name": "Path 14690",
    d: "M351.572,12.145H362.1a5.263,5.263,0,1,0-2.348-9.973,5.226,5.226,0,0,0-2.348-.552,5.279,5.279,0,0,0-1.484.214,6.072,6.072,0,1,0-4.346,10.312m0-9.716a3.651,3.651,0,0,1,2.983,1.553l.609.867.941-.486a2.83,2.83,0,0,1,2.939.212l.705.5.705-.5A2.833,2.833,0,1,1,362.1,9.716H351.572a3.643,3.643,0,1,1,0-7.287Z",
    transform: "translate(-288.854 0)",
    fill: "#1b7934"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperlessV2);
export default __webpack_public_path__ + "static/media/paperless-v2.a8ca91e67a34ac0f433e35299cc58c3c.svg";
export { ForwardRef as ReactComponent };